export default "__VITE_ASSET__4drP6aqs__"